const numeral = require('numeral');
const moment = require('moment');
const NP = require('number-precision');
NP.enableBoundaryChecking(false);
const {
  days_config
} = require('./options.jsx');
module.exports.capitalize = function (string) {
  let str = String(string || '');
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};
module.exports.getSpacedPhoneNumber = function (phone_number) {
  let returned_str = '';
  phone_number = String(phone_number || '');
  phone_number = phone_number.split(' ').join('');
  if (phone_number.indexOf('+33') === 0) {
    phone_number = phone_number.substring(3);
    phone_number = '0' + phone_number;
  } else if (phone_number.indexOf('33') === 0) {
    phone_number = phone_number.substring(2);
    phone_number = '0' + phone_number;
  }
  for (let i = 0; i < phone_number.length; i++) {
    if (i > 0 && i % 2 === 0) {
      returned_str += ' ';
    }
    returned_str += phone_number[i];
  }
  return returned_str;
};
const allowed_values = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
module.exports.cleanNumber = function (number = '', positive, int, digits) {
  if (typeof number === 'number') {
    number = String(number);
  } else if (typeof number !== 'string') {
    return '0';
  }
  const allowed = allowed_values.slice(0);
  if (!positive) allowed.push('-');
  if (!int) {
    allowed.push(',');
    allowed.push('.');
  }
  const value = Array.from(number || '').filter(letter => allowed.includes(letter)).join('').split(',').join('.').split('.');
  let safe_value = value[0] || '';
  if (value.length > 1) {
    const digits_str = value[1] + value.slice(2).join('');
    safe_value += '.' + (digits ? digits_str.slice(0, parseInt(digits)) : digits_str);
  }
  const is__negative = positive ? false : safe_value.startsWith('-');
  if (is__negative) {
    safe_value = '-' + safe_value.split('-').join('');
  } else if (!positive) {
    safe_value = safe_value.split('-').join('');
  }
  if (safe_value === '.') {
    return '0.';
  } else if (safe_value === '-.') {
    return '-0.';
  }
  return safe_value;
};
function safeNumeral(value = '') {
  if (typeof value === 'number') value = String(value);
  let safe_value = module.exports.cleanNumber(value);
  if (safe_value.startsWith('.')) {
    safe_value = '0' + safe_value;
  }
  if (safe_value.endsWith('.')) {
    safe_value = safe_value.slice(0, safe_value.length - 1);
  }
  if (value && isNaN(parseFloat(safe_value))) {
    return '0';
  }
  return safe_value || '0';
}
module.exports.safeNumeral = safeNumeral;
module.exports.getUrlParameter = function (name, custom_str) {
  let search;
  if (typeof custom_str === 'string') {
    search = custom_str.startsWith('?') ? custom_str.slice(1) : custom_str;
    search = search.split('&');
  } else {
    const has_params = document.location.href.includes('?');
    if (!has_params) return undefined;
    search = document.location.href.split('?')[1].split('&');
  }
  const slug = search.find(slug => slug.startsWith(name + '='));
  if (typeof slug === 'undefined') return undefined;
  return decodeURI(slug.slice((name + '=').length));
};
module.exports.getMinMaxSeats = function (space) {
  if (space.max_number_seat !== '') {
    return {
      min: 1,
      max: space.max_number_seat
    };
  }
  if (space.number_seat !== '') {
    return {
      min: 1,
      max: space.number_seat
    };
  }
  numeral.locale('en');
  if (space.disposition_seat) {
    return ['u', 'classe', 'board', 'theater'].reduce(function (infos, field) {
      infos.min = 1;
      if (typeof infos.max === 'undefined') {
        infos.max = numeral(safeNumeral((space.disposition_seat[field] || {}).place)).value();
      } else if ((space.disposition_seat[field] || {}).place > infos.max) {
        infos.max = numeral(safeNumeral((space.disposition_seat[field] || {}).place)).value();
      }
      return infos;
    }, {});
  }
};
module.exports.distance = function ({
  lat1,
  lat2,
  lng1,
  lng2
}) {
  const R = 6371e3; // m

  const φ1 = lat1 * Math.PI / 180; // φ, λ (radians)
  const φ2 = lat2 * Math.PI / 180;
  const Δφ = (lat2 - lat1) * Math.PI / 180;
  const Δλ = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // distance (m)
};

/*
	get lat coordinate diff for radius km
*/
module.exports.getCoordinatesRange = function ({
  lat,
  lng,
  radius = 2
}) {
  const range = 1 / (111.19492664455875 / radius);
  const coordinates = [{
    min_lat: lat - range,
    max_lat: lat + range
  }, {
    min_lng: lng - range,
    max_lng: lng + range
  }];
  return coordinates;
};

/**
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
 *
 * @param { Object } params
 *
 * @returns { String } Prix de l'espace
**/
module.exports.getSpaceAmount = function ({
  pricings,
  disposition_seat,
  schedule_price,
  people,
  date,
  start_hour,
  end_hour,
  space_type,
  roles = undefined
}) {
  const self = module.exports;
  let amount, interval;
  if (start_hour && end_hour) {
    interval = end_hour - start_hour;
    interval = parseInt(interval, 10);
    if (isNaN(interval)) interval = undefined;
  }
  if (roles === 'company_employee') {
    if (people > 0 === false || interval > 0 === false) return '0';
    amount = numeral(1).multiply(self.formatNum(interval, '0.00')).multiply(self.formatNum(people, '0')).format('0[.]00');
    return amount;
  }
  if (space_type === 'b_seminar') {
    if (start_hour === 'day') {
      const infos = (pricings || {})["disposition_seat"] || {};
      if ((infos.price_day || {})[date]) {
        amount = self.formatNum(infos.price_day[date], '0.00');
      } else {
        amount = self.formatNum(disposition_seat.price_day, '0.00');
      }
    } else if (start_hour === 'morning' || start_hour === 'afternoon') {
      const infos = (pricings || {})["disposition_seat"] || {};
      if ((infos.price_half_day || {})[date]) {
        amount = self.formatNum(infos.price_half_day[date], '0.00');
      } else {
        amount = self.formatNum(disposition_seat.price_half_day, '0.00');
      }
    }
  } else {
    if (people > 0 === false || interval > 0 === false) return '0';
    if (interval > 0 && interval <= 3) {
      if (pricings && pricings.one_three && pricings.one_three[date] && pricings.one_three[date].price) {
        amount = self.formatNum(pricings.one_three[date].price, '0.00');
      } else {
        amount = self.formatNum(schedule_price.one_three.price, '0.00');
      }
      amount = numeral(amount).multiply(interval).multiply(people).format('0[.]00');
    } else if (interval > 3 && interval <= 7) {
      if (pricings && pricings.four_seven && pricings.four_seven[date] && pricings.four_seven[date].price) {
        amount = self.formatNum(pricings.four_seven[date].price, '0.00');
      } else {
        amount = self.formatNum(schedule_price.four_seven.price, '0.00');
      }
      amount = numeral(amount).multiply(interval).multiply(people).format('0[.]00');
    } else if (interval > 7) {
      if (pricings && pricings.height_more && pricings.height_more[date] && pricings.height_more[date].price) {
        amount = self.formatNum(pricings.height_more[date].price, '0.00');
      } else {
        amount = self.formatNum(schedule_price.height_more.price, '0.00');
      }
      amount = numeral(amount).multiply(interval).multiply(people).format('0[.]00');
    }
  }
  return amount;
};

/**
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
 *
 * @param { Object } params
 * @param { Object } params.service un Service avec les infos relatives au prix
 *
 * @returns { String } Prix TTC du service
**/
module.exports.getTTCServiceAmount = function ({
  service
}) {
  const num = module.exports.num;
  if (!service) return;
  let total = 0;
  if (service.tva_type === 'multiple') {
    (service.multiple_prices || []).forEach(function (price) {
      const VAT_multiplier = num(price.tva, 3) > 1 ? num(price.tva, 3) : 1;
      total = num(total + num(num(price.amount) * VAT_multiplier));
    }, 0);
  } else {
    const VAT_multiplier = num(service.tva_type, 3) > 1 ? num(service.tva_type, 3) : 1;
    total = num(total + num(num(service.simple_price) * VAT_multiplier));
  }
  return total;
};

/**
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
 *
 * @param { Object } params
 * @param { Object } params.service un Service avec les infos relatives au prix
 * @param { Object } params.start un Service avec les infos relatives au prix
 * @param { Object } params.end un Service avec les infos relatives au prix
 * @param { Object } params.quantity Quantité choisie par le client
 *
 * @returns { String } Prix TTC du service
**/
module.exports.getTotalServiceAmount = function ({
  service,
  quantity = 1,
  hours_count
}) {
  if (!service) return;
  const qty_multiplier = service.unit === 'per_hour' ? num(hours_count, 0) : num(quantity, 0);
  const VATs_config = service.tva_type === 'multiple' ? service.multiple_prices || [] : [{
    amount: service.simple_price,
    tva: service.tva_type,
    id: 'unique'
  }];
  let total_price = 0;
  VATs_config.forEach(function (infos) {
    infos.amount = num(infos.amount);
    infos.tva = num(infos.tva, 3) > 1 ? num(infos.tva, 3) : 1;
    if (infos.amount > 0 === false) return;
    let line_raw_total = num(infos.amount * qty_multiplier);
    let line_total = num(line_raw_total * infos.tva);
    total_price = num(total_price + line_total);
  });
  return total_price;
};
module.exports.getTotalHTServiceAmount = function ({
  service,
  start,
  end,
  quantity = 1
}) {
  if (!service) return;
  let total;
  if (service.tva_type !== 'multiple') {
    total = num(service.simple_price);
  } else {
    total = service.multiple_prices.reduce(function (total, price) {
      return num(total + num(price.amount));
    }, 0);
  }
  if (service.unit === 'per_hour') {
    let hours_count = !end ? 1 : num(end, 0) - num(start, 0);
    if (hours_count < 0) hours_count *= -1;
    total = num(total) * hours_count;
  }
  return numeral(total).multiply(num(quantity, 0)).format('0.00');
};
module.exports.isTrue = function (value) {
  return [true, 'true'].includes(value);
};
module.exports.isFalse = function (value) {
  return [false, 'false'].includes(value);
};
module.exports.isNotTrue = function (value) {
  return [true, 'true'].includes(value) === false;
};
module.exports.isNotFalse = function (value) {
  return [false, 'false'].includes(value) === false;
};
function formatNum(number, format = '0,0[.]00') {
  return numeral(module.exports.safeNumeral(number)).format(format).split(',').join(' ');
}
module.exports.formatNum = formatNum;
module.exports.getOpenInfos = function ({
  ...params
}) {
  const {
    isTrue
  } = module.exports;
  const {
    schedule,
    type,
    period,
    date,
    availability = {}
  } = params;
  const custom_availability = availability[date] || {};
  moment.locale('fr');
  const week_day = days_config[moment(date).isoWeekday() - 1];
  let is__closed_in_space = isTrue((schedule[week_day] || {}).open) === false;
  if (type === 'b_seminar' || type === 'c_open_coworking_space') {
    if (period && period !== 'day')
      // open if the period is open
      {
        is__closed_in_space = !isTrue((schedule[week_day] || {})[period]);
        if (custom_availability[period] === 'close') {
          return [false, true];
        } else {
          return custom_availability[period] === 'open' ? [true, true] : [!is__closed_in_space, false];
        }
      } else if (period === 'day')
      // open is BOTH morning and afternoon are open
      {
        let morning_closed = false,
          afternoon_closed = false;
        const is__custom = ['morning', 'afternoon'].some(name => ['close', 'open'].includes(custom_availability[name]));
        const custom_open = !is__custom ? false : ['morning', 'afternoon'].every(name => custom_availability[name] === 'open');
        if (custom_open) return [true, true];
        if (custom_availability.morning === 'close') {
          morning_closed = true;
        } else {
          morning_closed = !isTrue((schedule[week_day] || {}).morning);
        }
        if (custom_availability.afternoon === 'close') {
          afternoon_closed = true;
        } else {
          afternoon_closed = !isTrue((schedule[week_day] || {}).afternoon);
        }
        return [!morning_closed && !afternoon_closed, is__custom];
      } else
      // open if morning, afternoon or both are open
      {
        let morning_closed = false,
          afternoon_closed = false;
        const is__custom = ['morning', 'afternoon'].some(name => ['close', 'open'].includes(custom_availability[name]));
        const custom_open = !is__custom ? false : ['morning', 'afternoon'].some(name => custom_availability[name] === 'open');
        if (custom_open) return [true, true];
        if (custom_availability.morning === 'close') {
          morning_closed = true;
        } else {
          morning_closed = !isTrue((schedule[week_day] || {}).morning);
        }
        if (custom_availability.afternoon === 'close') {
          afternoon_closed = true;
        } else {
          afternoon_closed = !isTrue((schedule[week_day] || {}).afternoon);
        }
        return [!morning_closed || !afternoon_closed, is__custom];
      }
  } else {
    if (custom_availability === 'close') return [false, true];
    if (custom_availability === 'open') return [true, true];
    return [!is__closed_in_space, false];
  }
};
module.exports.shuffleArray = function (array = []) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};
function num(number, digits = 2) {
  const as_number = numeral(safeNumeral(number)).value();
  if (isNaN(as_number)) return 0;
  if (Number.isInteger(as_number)) return as_number;
  return NP.round(as_number, digits);
}
module.exports.num = num;
module.exports.isValidDate = function (date = '') {
  if (!date) return false;
  if (typeof date !== 'string') return false;
  if (date.length < 10) return false;
  if (date.toLowerCase().includes('invalid')) return false;
  return true;
};
module.exports.getBookingStartHour = function (booking = {}) {
  let start_hour = moment(booking.date).startOf('day');
  const week_day = days_config[start_hour.isoWeekday() - 1];
  const space = booking.coworking_space || {};
  const schedule = (space.schedule || {})[week_day] || {};
  let first_hour;
  if (['b_seminar', 'c_open_coworking_space'].includes(space.type)) {
    first_hour = booking.type === 'afternoon' ? schedule.afternoon_from : schedule.morning_from;
  } else {
    first_hour = booking.start_hour;
  }
  if (first_hour > 0) {
    start_hour.add(num(first_hour, 0), 'hours');
  }
  return start_hour.format();
};

/**
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
 *
 * @param { String, Object } date date ISO ou parsable par moment
 * @param { String, Number } hour heure de la résa (par ex: 10, "10h")
 * @param { String, Number } delta nb d'heures minimum avant résa
 * @param { String, Number } now date ISO utilisée pour savoir si on dépasse ou non
 * @param { String, Number } overflow nb de minutes de dépassement autorisées
 *
 * @returns { Boolean } renvoi si le delta est dépassé ou non
**/
module.exports.isAfterDelta = function ({
  date,
  hour,
  delta,
  now,
  overflow = 0
}) {
  const booking_start = moment(date).startOf('day').add(num(hour), 'hours');
  const now_moment = (now ? moment(now) : moment()).add(1, 'minutes');
  const overflow_mn = num(overflow) > 0 ? num(overflow, 0) + 1 : 0;
  if (num(delta) > 0 === false) {
    if (!now_moment.isAfter(booking_start, 'minute')) return false;

    // le dépassement en minutes ne s'applique que sur la dernière heure
    return now_moment.subtract(overflow_mn, 'minutes').isAfter(booking_start, 'minute');
  }
  return now_moment.isAfter(booking_start.subtract(delta, 'hour'));
};
module.exports.getSpacesMaxBookable = function (spaces = []) {
  return spaces.reduce(function (max, space) {
    const space_max = getSpaceMaxBookable(space);
    return space_max > max ? space_max : max;
  }, 0);
};
function getSpaceMaxBookable(space) {
  const max_per_booking = num(space.max_number_seat, 0);
  const seats = space.type === 'b_seminar' ? Object.keys(space.disposition_seat || {}).reduce(function (max, name) {
    const seats = num(space.disposition_seat[name].place, 0);
    return max > seats ? max : seats;
  }, 0) : num(space.number_seat, 0);
  const max_bookable = max_per_booking > 0 || max_per_booking === '0' ? max_per_booking > seats ? seats : max_per_booking : seats;
  return max_bookable;
}
module.exports.getSpaceMaxBookable = getSpaceMaxBookable;
module.exports.isPromoCodeValid = function (code) {
  if (!code || typeof code !== 'string') return false;
  const letters = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ');
  const numbers = Array.from({
    length: 10
  }).map((_v, i) => String(i));
  const allowed = ['-', '_'].concat(letters).concat(numbers);
  return Array.from(code.toUpperCase()).every(char => allowed.includes(char));
};

/**
 * @version 1.0.0
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
 *
 * @example ['3.33', '3.33', '3.34']
 *
 * @description retourne un tableau de prix unitaire de l'espace (1h une personne)
 * l'avantage de faire un tableau est que si la division ne tombe pas juste
 * le dernier élément du tableau comble le manque pour arriver au total exact
 * sans ça on aurait quelque chose comme 1c restant
 * ['3.33', '3.33', '3.34'] pour un total de 10.00 par exemple
 *
 * @param { any } people nombre de personnes
 * @param { any } hours_count nombre d'heures
 * @param { any } amount
 * @returns { Array.<number> } Tableau de prix unitaire (1h, 1 personne)
**/
module.exports.getAtomicSpacePrice = function (people, hours_count, amount) {
  const quantity = num(num(people, 0) * num(hours_count, 0), 0);
  const base_unit_price = num(num(amount) / quantity);
  let counter = num(amount);
  return Array.from({
    length: quantity
  }).reduce(function (parts, _v, i) {
    if (i === quantity - 1)
      // on retourne ce qu'il reste pour éviter l'arrondi
      {
        return parts.concat([counter]);
      }
    counter = num(counter - base_unit_price);
    return parts.concat([base_unit_price]);
  }, []);
};
module.exports.getBookingServiceQty = function ({
  start,
  end,
  qty,
  service
}) {
  if (service.unit === 'per_hour') {
    const diff = num(end, 0) - num(start, 0);
    if (diff < 0) return diff * -1;
    return diff || 1;
  }
  if (service.unit === 'customer_qty') {
    return num(qty, 0);
  }
  return 1;
};
module.exports.getBookingServiceRowPrices = function ({
  ...params
}) {
  const {
    quantity,
    service
  } = params;
  let qty_multiplier = service.unit !== 'customer_qty' ? 1 : num(quantity, 0);
  if (service.unit === 'per_hour') {
    const hours_count = num(params.hours_count, 0);
    qty_multiplier *= hours_count;
  }
  if (!service || qty_multiplier > 0 === false) return getResult();
  let raw_price = 0,
    total_price = 0;
  const VATs_config = service.tva_type === 'multiple' ? service.multiple_prices || [] : [{
    amount: service.simple_price,
    tva: service.tva_type,
    id: 'unique'
  }];
  VATs_config.forEach(function (infos) {
    infos.amount = num(infos.amount);
    infos.tva = num(infos.tva, 3) > 1 ? num(infos.tva, 3) : 1;
    if (infos.amount > 0 === false) return;
    let line_raw_total = num(infos.amount * qty_multiplier);
    let line_total = num(line_raw_total * infos.tva);
    raw_price = num(raw_price + line_raw_total);
    total_price = num(total_price + line_total);
  });
  return getResult();
  function getResult() {
    const vat_price = num(total_price - raw_price);
    return {
      quantity: num(quantity, 0),
      raw_price,
      vat_price,
      total_price
    };
  }
};
module.exports.setServiceHeritedFields = function (service, title) {
  const {
    isTrue
  } = module.exports;
  if (!service || !title) return service;
  if (isTrue(title.with_range)) {
    service.open_range_start = num(service.open_range_start, 0);
    service.open_range_end = num(service.open_range_end, 0);
  } else {
    delete service.open_range_start;
    delete service.open_range_end;
  }
  if (isTrue(title.with_stock)) {
    if (num(service.daily_stock) > 0 === false) {
      if (!service.daily_stock && service.daily_stock !== 0) {
        delete service.daily_stock;
      } else {
        service.daily_stock = 0;
      }
    } else {
      service.daily_stock = num(service.daily_stock, 0);
    }
  } else {
    delete service.daily_stock;
  }
  return service;
};
module.exports.getBookingHoursCount = function getBookingHoursCount(booking) {
  const {
    start_hour,
    end_hour
  } = booking;
  const day_name = days_config[moment(booking.date).isoWeekday() - 1];
  const schedule_config = (booking.coworking_space || {}).schedule || {};
  const schedule = schedule_config[day_name] || {};
  if (start_hour === 'morning') {
    return getMorningHours();
  } else if (start_hour === 'afternoon') {
    return getAfternoonHours();
  } else if (start_hour === 'day') {
    return getMorningHours() + getAfternoonHours();
  } else {
    let count = num(end_hour, 0) - num(start_hour, 0);
    return count > 0 ? count : 0;
  }
  function getMorningHours() {
    let count = num(schedule.morning_to, 0) - num(schedule.morning_from, 0);
    return count > 0 ? count : 0;
  }
  function getAfternoonHours() {
    let count = num(schedule.afternoon_to, 0) - num(schedule.afternoon_from, 0);
    return count > 0 ? count : 0;
  }
};
module.exports.listBookingHours = function listBookingHours(params) {
  const {
    start_hour,
    end_hour,
    date,
    schedule
  } = params;
  const day_name = days_config[moment(date).isoWeekday() - 1];
  const day_schedule = (schedule || {})[day_name] || {};
  if (start_hour === 'morning') {
    return listMorningHours();
  } else if (start_hour === 'afternoon') {
    return listAfternoonHours();
  } else if (start_hour === 'day') {
    return listMorningHours().concat(listAfternoonHours());
  } else {
    let count = num(end_hour, 0) - num(start_hour, 0);
    return count > 0 === false ? [] : Array.from({
      length: count
    }).map(function (_v, i) {
      return String(num(start_hour, 0) + i);
    });
  }
  function listMorningHours() {
    let count = num(day_schedule.morning_to, 0) - num(day_schedule.morning_from, 0);
    if (count > 0 === false) return [];
    return Array.from({
      length: count
    }).map(function (_v, i) {
      return String(num(day_schedule.morning_from, 0) + i);
    });
  }
  function listAfternoonHours() {
    let count = num(day_schedule.afternoon_to, 0) - num(day_schedule.afternoon_from, 0);
    if (count > 0 === false) return [];
    return Array.from({
      length: count
    }).map(function (_v, i) {
      return String(num(day_schedule.afternoon_from, 0) + i);
    });
  }
};
module.exports.getCancelError = function (booking) {
  const limit_date = moment(module.exports.getBookingStartHour(booking));
  const space = booking.coworking_space || {};
  let limit_info = '4h';
  if (space.type === 'b_seminar' && space.cancellation_condition === 'non_remboursable') {
    const error = {
      error: 'Les réservations de cet espace ne sont pas remboursables.',
      ERROR_CODE: 'SPACE_NOT_REFOUNDABLE'
    };
    return error;
  }
  if (space.type === 'b_seminar') {
    const days = num(space.cancellation_condition_duration, 0);
    limit_date.subtract(days, 'days');
    limit_info = days + ' jour' + (days > 1 ? 's' : '');
  } else
    // can be refunded until 4h before booking date
    {
      limit_date.subtract(4, 'hours');
    }
  if (moment().isSameOrAfter(limit_date)) {
    const error = {
      error: 'Impossible à moins de ' + limit_info + ' de la réservation.',
      ERROR_CODE: 'TIME_LIMIT'
    };
    return error;
  }
};
